import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getSubNavUsers: () => NavRoute = () => ({
	name: getName()
	, security: security => security.coreFeatures
    , href: 'admin/users/list'
	, children: getUserAreas()
    , isSubNav: true
});

function getName() : string {
	let name: string;
	let url = globalThis.location.href;
	
	if (
		url.includes('admin/users/edit/')
		|| url.includes('admin/users/edit/security/')
		|| url.includes('admin/users/edit/roles/')
		|| url.includes('users/edit/notifications/')
		|| url.includes('admin/users/edit/audit-history/')
		|| url.includes('admin/users/edit/login-history/')
	) { name = "Edit User"; } 
	else { name = "Users"; }

	return name;
}

function getUserAreas() : NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;

	if (url.includes('admin/users/edit/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('admin/users/edit/security/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('admin/users/edit/roles/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/notifications/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('admin/users/edit/audit-history/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('admin/users/edit/login-history/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	// Users List and Global Login History
	if (id === "") { 
		return [
			{
				name: 'All Users'
				, exact: true
				, path: 'admin/users/list'
                , activeNavLink: 'admin/users/list'
                , secondaryNav: [ 'Admin', 'Users', 'List' ]
			}
            , {
				name: 'Global Login History'
				, exact: true
				, path: 'admin/users/login-history'
                , activeNavLink: 'admin/users/login-history'
                , secondaryNav: [ 'Admin', 'Users', 'Login History' ]
			}
		]; 
	}

	// Creating a new User
	if (+id === 0) {
		return [
			{
				name: 'Back'
				, exact: true
				, path: `admin/users/list`
			}
            , {
				name: 'Details'
				, exact: true
				, path: `users/edit-user/${id}`
                , activeNavLink: 'admin/users/edit/details'
				, secondaryNav: ['Admin', 'Users', 'Edit User', 'Details']
			}
		];
	}

	// User details
	return [
		{
			name: 'Back'
			, exact: true
			, path: `admin/users/list`
		}
        , {
			name: 'Details'
			, exact: true
			, path: `admin/users/edit/details/${id}`
            , activeNavLink: 'admin/users/edit/details'
			, secondaryNav: ['Admin', 'Users', 'Edit User', 'Details']
		}
        , {
			name: 'Security'
			, exact: true
			, path: `admin/users/edit/security/${id}`
            , activeNavLink: 'admin/users/edit/security'
			, secondaryNav: ['Admin', 'Users', 'Edit User', 'Security']
		}
        , {
			name: 'Roles'
			, exact: true
			, path: `admin/users/edit/roles/${id}`
            , activeNavLink: 'admin/users/edit/roles'
			, secondaryNav: ['Admin', 'Users', 'Edit User', 'Roles']
		}
        , {
			name: 'Notifications'
			, exact: true
			, path: `admin/users/edit/notifications/${id}`
            , activeNavLink: 'admin/users/edit/notifications'
			, secondaryNav: ['Admin', 'Users', 'Edit User', 'Notifications']
		}
        , {
			name: 'Login History'
			, exact: true
			, path: `admin/users/edit/login-history/${id}`
            , activeNavLink: 'admin/users/edit/login-history'
			, secondaryNav: ['Admin', 'Users', 'Edit User', 'Login History']
		}
        , {
			name: 'Audit History'
			, exact: true
			, path: `admin/users/edit/audit-history/${id}`
            , activeNavLink: 'admin/users/edit/audit-history'
			, secondaryNav: ['Admin', 'Users', 'Edit User', 'Audit History']
		}
	];
}
